module.exports = __webpack_public_path__ + "components/flag/static/square/es-ct-dd061888f57dfe4c037aff998181c5f1.svg";